
import React from 'react';

interface ErrorBoundaryState {
  hasError: boolean;
  error: Error | null;
}

interface ErrorBoundaryProps {
  children: React.ReactNode;
}

export const ErrorFallback = ({ error }: { error: Error }) => {
  console.error("App rendering error:", error);
  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-4 bg-red-50">
      <h1 className="text-2xl font-bold text-red-700 mb-4">Something went wrong</h1>
      <p className="text-red-600 mb-4">{error.message}</p>
      <button 
        className="px-4 py-2 bg-blue-600 text-white rounded"
        onClick={() => window.location.href = '/'}
      >
        Go back home
      </button>
    </div>
  );
};

export class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error) {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error("Caught app error:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return <ErrorFallback error={this.state.error as Error} />;
    }
    return this.props.children;
  }
}
